import { render, staticRenderFns } from "./CreateOtherPayment.vue?vue&type=template&id=5e2c48a1"
import script from "./CreateOtherPayment.vue?vue&type=script&lang=js"
export * from "./CreateOtherPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports